<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
.help-center {
  height: 100vh;
  .content-view {
    &.has-header {
      padding-top: 44px;
    }

    .help-category {
      background: white;
      margin-bottom: 5px;
      display: flex;
      height: 100px;
      .category-name {
        text-align: center;
        color: #333;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 97px;
        position: relative;
        padding-right: 11px;
        img.category-icon {
          width: 25px;
          height: 25px;
          position: relative;
          left: 3px;
          margin-bottom: 6px;
        }
        .split-line {
          position: absolute;
          right: 0;
          height: 100%;
        }
        .title {
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          span {
            position: absolute;
            right: -10px;
          }
          img {
            height: 9px;
            width: 6px;
          }
        }
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        padding: 10px 15px;
        li {
          flex: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #333;
          position: relative;
          text-align: center;
          &:nth-child(1),
          &:nth-child(3) {
            span {
              position: relative;
              right: 5.5px;
            }
          }
          &:nth-child(2),
          &:nth-child(4) {
            span {
              position: relative;
              left: 5.5px;
            }
          }
          &:nth-child(1),
          &:nth-child(2) {
            span {
              position: relative;
              bottom: 2.5px;
            }
          }
          &:nth-child(3),
          &:nth-child(4) {
            span {
              position: relative;
              top: 5px;
            }
          }
          &:nth-child(2) {
            &::after {
              .setLeftLine();
            }
          }
          &:nth-child(3) {
            &::after {
              .setTopLine();
            }
          }
          &:nth-child(4) {
            &::after {
              .setTopLine();
            }
            &::before {
              .setLeftLine();
            }
          }
        }
      }
    }
  }
  .page-bottom {
    height: 90px;
    position: absolute;
    padding-top: 15px;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    color: #666;
    font-size: 16px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
}
</style>

<template>
  <div class="help-center">
    <myHeader showBack v-show="!isApp">
      <div slot="title">帮助与客服</div>
    </myHeader>

    <div class="content-view" :class="{ 'has-header': !isApp }">
      <div class="help-category">
        <div class="category-name" @click="toSubCategory(1)">
          <img class="category-icon" src="../../../../image/help/film.png" alt="" />
          <div class="title">
            <div>电影票问题</div>
            <span>
              <img src="../../../../image/help/arrow-right.png" alt="" />
            </span>
          </div>
          <img class="split-line" src="../../../../image/help/split-line.png" alt="" />
        </div>
        <ul>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/cCQYnJ926749')">
            <span>
              如何购票
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/UJfdyH525193')">
            <span>
              如何取票
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/vwxmSR042594')">
            <span>
              退票/改签
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/FqQsDI053874')">
            <span>
              出票失败
            </span>
          </li>
        </ul>
      </div>
      <div class="help-category">
        <div class="category-name" @click="toSubCategory(2)">
          <img class="category-icon" src="../../../../image/help/card.png" alt="" />
          <div class="title">
            <div>卡券问题</div>
            <span>
              <img src="../../../../image/help/arrow-right.png" alt="" />
            </span>
          </div>
          <img class="split-line" src="../../../../image/help/split-line.png" alt="" />
        </div>
        <ul>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/SVUlVg972788')">
            <span>
              绑定卡券
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/fkARNl102463')">
            <span> 查询卡券余额/<br />有效期 </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/uoftTR033758')">
            <span>
              解绑卡券
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/dZeEGo241933')" style="padding">
            <span> 卡券丢失/挂失<br />补卡 </span>
          </li>
        </ul>
      </div>
      <div class="help-category">
        <div class="category-name" @click="toSubCategory(3)">
          <img class="category-icon" src="../../../../image/help/account.png" alt="" />
          <div class="title">
            <div>账户问题</div>
            <span>
              <img src="../../../../image/help/arrow-right.png" alt="" />
            </span>
          </div>
          <img class="split-line" src="../../../../image/help/split-line.png" alt="" />
        </div>
        <ul>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/QOiscz286857')">
            <span>更改绑定手机号</span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/zJTfSa121108')">
            <span>
              账户注销
            </span>
          </li>
        </ul>
      </div>
      <div class="help-category">
        <div class="category-name" @click="toSubCategory(4)">
          <img class="category-icon" src="../../../../image/help/card_delay.png" alt="" />
          <div class="title">
            <div>延期问题</div>
            <span>
              <img src="../../../../image/help/arrow-right.png" alt="" />
            </span>
          </div>
          <img class="split-line" src="../../../../image/help/split-line.png" alt="" />
        </div>
        <ul>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/IBrPvZ356733')">
            <span>
              卡券延期规则
            </span>
          </li>
          <li @click="redirect('https://m.maizuo.com/mz-act/active/ssEDKf752685')">
            <span>
              延期流程
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="page-bottom">
      <div @click="toHelpCenter">
        <img src="../../../../image/help/assistant.png" alt="" />
        <span>专属客服（9:00-22:30）</span>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import { DatetimePicker, Actionsheet, MessageBox, Toast, Indicator } from 'mint-ui'
import { mapState, mapGetters } from 'vuex'

import icon from '../../../components/icon.vue'
import cookie from '../../../lib/cookie.js'
import CONSTANT from '../../../constant/cookie.js'

import moment from 'moment'
import myHeader from '../../../components/header'

import { app } from '../../../util/platform'
import Appbridge from '@maizuo-fe/jk-appbridge'
import setDocumentTitle from '../../../util/document-title'

export default {
  data() {
    return {}
  },
  mounted() {
    setDocumentTitle('帮助与客服')
  },
  components: {
    DatetimePicker,
    Actionsheet,
    icon,
    myHeader,
  },
  computed: {
    ...mapState({
      serviceUrl: state => state.service.serviceUrl,
    }),
    isApp() {
      return app.isMZFilm()
    },
    // isVIP() {
    //   let co = cookie(CONSTANT.COOKIE_CO) || CONSTANT.COOKIE_DEFAULT_CO
    //   if (co === CONSTANT.COOKIE_CO_IS_SDYXVIP) {
    //     return true
    //   }
    //   return false
    // },
  },
  methods: {
    toSubCategory(id) {
      this.$router.push({
        name: 'help-sub',
        params: {
          id,
        },
      })
    },
    toHelpCenter() {
      if (app.isMZFilm()) {
        Appbridge.redirect('customer-service')
        return
      }
      // let redirect_url = ''
      this.$store.dispatch('getServiceUrl', {}).then(() => {
        window.location.href = this.serviceUrl
      })
    },
    redirect(url) {
      window.open(url, '_blank')
    },
  },
}
</script>
